import React, { useState, useEffect } from "react";
import { Input, Button, message, Upload } from "@cloud/atom-ui";
import { i18n } from "@src/utils/i18n";
import * as nls from "../nls";
import { submitPreAudit, getAppInfoList } from "../thunk";
import UploadOutlined from '@cloud/atom-ui-icons/UploadOutlined';
import "./sytle.less";
import { useNavigate, useLocation } from "react-router-dom";
import CloseIcon from '../assets/close.svg';
import { cloneDeep } from "lodash";
import { queryString, APP_TYPE, getAppPathFromType } from "@src/utils/common";
import {urlDomainDeal} from "@src/utils/common";

export default () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const I18N = i18n(nls);
  const text = I18N;
  const typePosition = {
    xlsx: '120',
    xls: '120',
    pdf: '0',
    doc: '560',
    docx: '560',
    pptx: '400',
    ppt: '400',
    Photo: '360',
    other: '160'
  };
  const appId = queryString("id") || "";
  const paramsType = queryString("type") || "";
  // 已上传文件列表集合
  const [fileLists, setFileLists] = useState({
    functional: [],
    security: [],
    ucd: []
  });
  const [appInfo, setAppInfo] = useState(null); // 版本数据加载状态
  const [submitLoading, setSubmitLoading] = useState(false);
  const [functionalStatus, setFunctionalStatus] = useState(false);
  const [securityStatus, setSecurityStatus] = useState(false);
  const [ucdStatus, setUcdStatus] = useState(false);
  // 待提交文件
  const [submitFileList, setSubmitFileList] = useState({
    versionName: "", // 体验版 版本名
    aliasName: "", // 应用详情中的 aliasName
    functionalUuid: "", // 功能稳定表 uuid
    functionalFileName: "", // 功能稳定表 文件名
    securityUuid: "", // 安全表 uuid
    securityFileName: "", // 安全表 文件名
    ucdUuid: "", // UCD uuid
    ucdFileName: "", // UCD 文件名
    contactEmail: ""
  });

  // 改变待提交文件
  const changeSubmitFileList = (type, uuid, fileName) => {
    if (type === 'email') {
      setSubmitFileList({
        ...submitFileList,
        contactEmail: fileName.target.value
      });
    } else {
      if (!uuid && !fileName) {
        const list = cloneDeep(fileLists);
        list[type] = [];
        setFileLists(list);
      }
      setSubmitFileList({
        ...submitFileList,
        [`${type}Uuid`]: uuid,
        [`${type}FileName`]: fileName
      });
    }
  };

  // 上传控件参数
  const uploadParams = fileType => {
    const token = window.document.cookie.match(/X-XSRF-TOKEN=([^;]+)?/);
    return {
      beforeUpload(file) {
        if (file && file.size && file.size / 1024 / 1024 > 30) {
          message.error("上传文件大小不能超过30MB");
          return false
        }
      },
      name: "file",
      action: `/${process.env.REACT_APP_API_CONTEXT}/service/myAppService/uploadAuditFile?appId=${appId}&type=${paramsType}`,
      headers: {
        'X-XSRF-TOKEN': (token) ? token[1] : "",
      },
      accept: '.xlsx,.xls,.rar,.zip',
      fileList: fileLists[fileType],
      onChange(info) {
        if (info && info.file && info.file.size && info.file.size / 1024 / 1024 > 30) return false
        if (fileType === 'functional') {
          setFunctionalStatus(true)
        } else if (fileType === 'security') {
          setSecurityStatus(true)
        } else if (fileType === 'ucd') {
          setUcdStatus(true)
        }
        const { file, fileList } = info;
        setFileLists({ ...fileLists, [fileType]: fileList });
        if (file.status === "done") {
          if (fileType === 'functional') {
            setFunctionalStatus(false)
          } else if (fileType === 'security') {
            setSecurityStatus(false)
          } else if (fileType === 'ucd') {
            setUcdStatus(false)
          }
          if (file.response.status === 1) {
            const { fileName, uuId } = file.response.data;
            changeSubmitFileList(fileType, uuId, fileName);
          } else {
            message.error(file.response.errMsg || "文件上传失败");
          }
        }
      },
      onRemove() {
      }
    };
  };

  // 触发提交预审核
  const handleSubmitPreAudit = () => {
    let reg = /^[\w-+&]+(\.[\w-+&]+)*@[\w-]+(\.[\w-]+)*(\.[\w-]{1,})$/;
    if (!submitFileList.contactEmail || !reg.test(submitFileList.contactEmail) || submitFileList.contactEmail.length > 100) {
      message.error('邮箱格式不正确,请检查后重新提交', 2);
    } else {
      const canSubmit = !Object.keys(submitFileList).some(item => {
        return submitFileList[item] === "";
      });
      if (canSubmit && !submitLoading) {
        setSubmitLoading(true);
        submitPreAudit(submitFileList).then(result => {
          if (result.status === 1) {
            message.success("提交成功", 1, () => {
              navigate(`/${paramsType}/appdetailV2/editionManage?id=${appId}&type=${paramsType}`);
            });
          } else {
            setSubmitLoading(false);
            message.error(result.errMsg || "提交失败");
          }
        });
      }
    }
  };

  const renderLabel = (required = false, name = '', desc = '') => {
    return (
      <div className="label_content">
        <div className="label_name">{name}</div>
        <div className="label_desc">
          {required && <div className="label_required">*</div>}
          {desc}
        </div>
      </div>
    )
  };

  const getFileName = (fileName) => {
    //  避免安卓的时候上传时会转一次码，导致后台拿到的也是一件
    let fileNameSrt = fileName;
    try {
      fileNameSrt = decodeURIComponent(fileNameSrt);
    } catch (err) {
    }
    return fileNameSrt;
  };

  // 截取附件文件type
  const getFileInfo = (files, val) => {
    let fileUrl = files && files.split('?');
    let fileName = fileUrl && fileUrl[0] && fileUrl[0].split('/') || '';
    let fileTypeItem = fileName && fileName[fileName.length - 1].split('.');
    if (val && val === 'name') {
      const name = fileName[fileName.length - 1];
      let fileNameSrt = decodeURIComponent(name);
      try {
        fileNameSrt = decodeURIComponent(fileNameSrt);
      } catch (err) {
      }
      return fileNameSrt;
    } else {
      const type = fileTypeItem[fileTypeItem.length - 1].toLowerCase();
      return type;
    }
  };

  //获取当前文件的图标
  const getIconLocation = (fileItem) => {
    const type = getFileInfo(fileItem, 'type');
    const iconPosition = typePosition[type] || typePosition["other"];
    return { backgroundPosition: `0 -${iconPosition}px` }
  };

  // 文件下载
  const doRealDownload = async (fileName, filePath) => {
    let a = document.createElement('a');
    a.download = fileName ? fileName : getFileInfo(filePath, 'name');// 定义下载名称
    a.style.display = 'none';
    a.href = urlDomainDeal(filePath); // 设置文件路径
    document.body.appendChild(a);// 将创建的标签插入dom
    a.click();// 点击标签，执行下载
    document.body.removeChild(a);// 将标签从dom移除
  };

  const rederUpload = (loading = false, link = '', type = '') => {
    const { fileName, filePath } = fileLists[type]?.[0]?.response?.data || {};
    return filePath ? (
      <div className='readReport'>
        <div className="attachment_content" onClick={() => doRealDownload(fileName, filePath)}>
          <div className='icon-folder' style={getIconLocation(filePath)} />
          <span className='attachment_name'>{fileName ? getFileName(fileName) : getFileInfo(fileName, 'name')}</span>
        </div>
        <img className="close_icon" src={CloseIcon} onClick={() => changeSubmitFileList(type, "", "")} />
      </div>
    ) : (
      <div className="upload_content">
        <div className="upload_button">
          <Upload {...uploadParams(type)}>
            <Button loading={loading} icon={<UploadOutlined />}>{text.upload}</Button>
          </Upload>
          <Button href={link} type="link">{text.downloadExcel}</Button>
        </div>
        <div className="upload_limit">支持xlsx、xls、rar、zip格式</div>
      </div>
    )
  };

  useEffect(() => {
    getAppInfoList(appId, getAppPathFromType(paramsType)).then(res => {
      if (res?.status == 1) {
        setAppInfo(res?.data);
        let flist = submitFileList
        flist.aliasName = res?.data?.aliasName;
        flist.contactEmail = res?.data?.contactEmail || '';
        setSubmitFileList({
          ...flist,
          versionName: state?.versionName,
        });
      } else {
        message.error(res?.errMsg || "操作失败");
      }
    });
  }, []);

  return (
    <div>
      <div className="btn-div">
        <Button
          className="left-btn"
          type="default"
          onClick={() => navigate(`/${paramsType}/appdetailV2/editionManage?id=${appId}&type=${paramsType}`)}
        >
          返回
        </Button>
        <div className="top_title">上架资质审核</div>
        <div></div>
      </div>
      <div className="pre_subPre">
        <div className="name">
          <img src={urlDomainDeal(appInfo?.icon?.showUrl)} alt="" />
          <div>
            <div>{appInfo?.nameCn}</div>
            <span>{appInfo?.nameEn}</span>
          </div>
        </div>
        {/* 功能稳定性自检 */}
        <div className="flex">
          {renderLabel(true, text.func, text.funcTable)}
          {rederUpload(functionalStatus, `${window._domain_.docDomain}/docs/operation/guide/File/WeLink应用上架功能稳定性审核表.xlsx`, 'functional')}
        </div>
        {/* 安全自检 */}
        <div className="flex">
          {renderLabel(true, text.safe, text.safeTable)}
          {rederUpload(securityStatus, `${window._domain_.docDomain}/docs/operation/guide/File/应用上架安全性审核表.rar`, 'security')}
        </div>
        {/* UCD自检 */}
        <div className="flex">
          {renderLabel(true, text.UCD, text.UCDTable)}
          {rederUpload(ucdStatus, `${window._domain_.docDomain}/docs/operation/guide/File/应用上架UCD审核表.xlsx`, 'ucd')}
        </div>
        {/* 联系方式 */}
        <div className="flex">
          {renderLabel(true, text.contact, text.contactEmail)}
          <Input
            style={{ width: 600 }}
            value={submitFileList.contactEmail}
            onChange={(e) => changeSubmitFileList("email", "", e)} />
        </div>
        <div className="submit_button">
          <Button type="primary"
            loading={submitLoading}
            disabled={Object.keys(submitFileList).some(item => submitFileList[item] === "")}
            onClick={() => handleSubmitPreAudit()}
          >
            {text.submit}
          </Button>
        </div>
      </div>
    </div>
  )
};
